import {Component, OnInit} from '@angular/core';
import {UserSavedReportsService} from './user-saved-reports.service';
import {Report} from '../../model/report';
import {Dictionary} from '../../model/dictionary';
import {CommonService} from '../../common/common.service';
import {UserReportsService} from '../user-reports/user-reports.service';
import {forkJoin} from 'rxjs/observable/forkJoin';
import {NotifierService} from '../notifier/notifier.service';
import {NotificationType} from '../notifier/notification-type.enum';
import {UserSavedReportsPageService} from './user-saved-reports-page.service';
import {saveAs} from 'file-saver';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {User} from '../../model/user';
import {Router} from '@angular/router';
import { BreadcumbsService } from '../breadcumbs/breadcumbs.service';
import { MainMenuService } from '../header/main-menu/main-menu.service';
import {TopMenuService} from "../top-menu/top-menu.service";

@Component({
  selector: 'pbc-user-saved-reports',
  templateUrl: './user-saved-reports.component.html',
})
export class UserSavedReportsComponent implements OnInit {

  reportsSelected : Array<Report> = [];
  private reports : Array<Report> = [];
  private reportsExpanded : Array<Report> = [];
  private filteredReportsCounter : number = 0;
  reportsAreFiltered : boolean = false;
  private reportToOperateOn : Report;

  private loggedUserId : number = null;
  private loggedUser : User;

  private suggestedReports : Array<Report> = [];

  //pager
  pager: any = new Object();
  pagedReports: Array<Report> =[];
  private static pageSize: number = 10;
  private currentPage : number = 1;

  //Filtrowanie
  private fileFormatsForFilter : Array<string> = [];
  private fileFormatsForFilterSelected : Array<string> = [];
  private contentTypeForFilter : Array<Dictionary> = [];
  private contentTypeForFilterSelected : Array<Dictionary> = [];
  private thematicsFrequenciesForFilter : Array<Dictionary> = [];
  private thematicsFrequenciesForFilterSelected : Array<Dictionary> = [];
  private thematicsAreaForFilter : Array<Dictionary> = [];
  private thematicsAreaForFilterSelected : Array<Dictionary> = [];
  private thematicsProductsForFilter : Array<Dictionary> = [];
  private thematicsProductsForFilterSelected : Array<Dictionary> = [];
  private thematicsInstitutionForFilter : Array<Dictionary>  = [];
  private thematicsInstitutionForFilterSelected : Array<Dictionary>  = [];
  private thematicsClientGroupsForFilter : Array<Dictionary> = [];
  private thematicsClientGroupsForFilterSelected : Array<Dictionary> = [];
  private dateFromFilter : Date;
  private dateToFilter : Date;
  showFilterPopup : boolean = false;

  //Sortowania
  orderByField : string = "title";
  orderAsc : boolean =  true;

  //Popupy z demo
  showNoAccessPopup : boolean = false;
  showContactUsPopup : boolean = false;
  private currentReport : Report;
  showReportShare : boolean = false;
  shareReportForm : FormGroup;
  //Formularz do kontaktu
  private contactForm: FormGroup;

  constructor(private userSavedReportsService : UserSavedReportsService,
              private topMenuService: TopMenuService,
              private commonService : CommonService,
              private userReportsService : UserReportsService,
              private notifierService : NotifierService,
              private pagerService : UserSavedReportsPageService,
              private routerService : Router,
              private breadcumbsService: BreadcumbsService) {
  }

  ngOnInit() {

    let authData = JSON.parse(localStorage.getItem('auth_data'));
    this.loggedUserId = authData.user.id;
    this.loggedUser = authData.user;
    const userName = authData.user.firstName + ' ' + authData.user.lastName;

    this.getDictionaries();
    this.getReports(true);
    this.shareReportForm = new FormGroup({
      'email' : new FormControl('', [Validators.email, Validators.required]),
      'message' : new FormControl('Dzień dobry, być może zainteresuje Cię ten raport. Pozdrawiam, ' + userName),
      'sendCopy' : new FormControl('')
    });


    this.contactForm = new FormGroup({
      'email': new FormControl({value:this.loggedUser.email, disabled : true}, [Validators.required, Validators.email]),
      'firstLastName' : new FormControl({value: this.loggedUser.firstName.concat(' ', this.loggedUser.lastName), disabled : true}, Validators.required),
      'phoneNumber' : new FormControl({value: this.loggedUser.workPhone, disabled  : true}),
      'message' : new FormControl(''),
      'send-copy' : new FormControl(false),
      'agreement-rules' : new FormControl(false, Validators.requiredTrue)
    });

  }


  private showHideMoreOnReport(report : Report) {
    let position = this.reportsExpanded.indexOf(report);
    if (position == -1)
      this.reportsExpanded.push(report);
    else
      this.reportsExpanded.splice(position, 1);
  }

  removeFromSavedClick() {
    let reportsSelectedIds : Array<number>;

    reportsSelectedIds = this.reportsSelected.map((report : Report)=>report.id);
    if (reportsSelectedIds.length >0)
      this.userSavedReportsService.removeReportsFromSaved(this.loggedUserId, reportsSelectedIds).subscribe(
        result => {
          if (result.status != 1)
            this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
              "Wystąpił błąd! Nie usunięto z zaznaczonych raportów z zapisanych");
          else {
            this.notifierService.notify(NotificationType.SUCCESS_NOTIFICATION,
              "Usunięta zaznaczone raporty z zapisanych");
            this.getReports(true);
            this.reportsSelected = [];
          }
        },
        error=>{
          console.log(error);
          this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
            "Wystąpił błąd! Nie usunięto zaznaczonych raportów z zapisanych")
        }
      )
  }

  showFilterPopupClick(show : boolean) {
    this.showFilterPopup = show;
  }

  private filterReportsClick() {
    this.showFilterPopup = false;
    this.reportsAreFiltered = true;
    this.getReports(true);
  }

  private clearFiltersClick() {
    this.fileFormatsForFilterSelected = [];
    this.thematicsAreaForFilterSelected = [];
    this.thematicsClientGroupsForFilterSelected = [];
    this.thematicsFrequenciesForFilterSelected = [];
    this.thematicsInstitutionForFilterSelected = [];
    this.thematicsProductsForFilterSelected = [];
    this.contentTypeForFilterSelected = [];

    this.getReports(true);
    this.reportsAreFiltered = false;
  }

    updateUserReportsCount(){
        let filterParams = {};
        filterParams['id']=this.loggedUserId;
        this.userSavedReportsService.getReportsCount(filterParams).subscribe(
            result => {
                this.topMenuService.userReportsCount.emit(result.record);
            })
    }

  private getReports(returnResult : boolean) {
    this.updateUserReportsCount();
    let filterParams = {};

    filterParams['id']=this.loggedUserId;
    filterParams['sortString'] = this.createSortString();

    if (this.fileFormatsForFilterSelected.length > 0)
        filterParams['fileFormat'] = this.fileFormatsForFilterSelected;
    if (this.contentTypeForFilterSelected.length > 0)
        filterParams['content_type'] = this.contentTypeForFilterSelected.map(contentType=>contentType.id);
    if (this.thematicsAreaForFilterSelected.length > 0)
        filterParams['thematics_area'] = this.thematicsAreaForFilterSelected.map((area:Dictionary)=>area.id);
    if (this.thematicsClientGroupsForFilterSelected.length > 0)
        filterParams['thematics_client_groups'] = this.thematicsClientGroupsForFilterSelected.map((clientGroup : Dictionary)=>clientGroup.id);
    if (this.thematicsInstitutionForFilterSelected.length > 0)
        filterParams['thematics_institution'] = this.thematicsInstitutionForFilterSelected.map((institution:Dictionary)=>institution.id);
    if (this.thematicsProductsForFilterSelected.length > 0)
        filterParams['thematics_products'] = this.thematicsProductsForFilterSelected.map((product:Dictionary)=>product.id);
    if (this.thematicsFrequenciesForFilterSelected.length > 0)
        filterParams['thematics_frequency'] = this.thematicsFrequenciesForFilterSelected.map((freq:Dictionary)=>freq.id);
    if (this.dateFromFilter)
        filterParams['publish_date_from'] = this.dateFromFilter;
    if (this.dateToFilter)
        filterParams['publish_date_to'] = this.dateToFilter;

    this.userSavedReportsService.getReports(filterParams).subscribe(
      result => {
        if (result.status != 1)
          this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, "Wystąpił błąd! Nie pobrano raportów");
        else {
          if (returnResult) {
            this.reports = result.record;
            this.filteredReportsCounter = this.reports.length;
            this.setPage(this.currentPage);
          } else
            this.filteredReportsCounter = result.record.length;
        }
          this.breadcumbsService.setSubfolder.emit('Zapisane');
      },
      error=> {
        console.log(error);
        this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, "Wystąpił błąd! Nie pobrano raportów");
          this.breadcumbsService.setSubfolder.emit('Zapisane');
      }
    )
  }

  private addRemoveReportSelected(report : Report) {
    let reportPosition = this.reportsSelected.indexOf(report);
    if (reportPosition === -1)
      this.reportsSelected.push(report);
    else
      this.reportsSelected.splice(reportPosition, 1);
  }

  private addRemoveFilterCriterion(criterion : Dictionary, criterionCollection : Array<Dictionary>) {
      let criterionPosition = criterionCollection.indexOf(criterion);
      if (criterionPosition === -1)
          criterionCollection.push(criterion);
      else
          criterionCollection.splice(criterionPosition, 1);

      this.getReports(false);
  }

  cleanReportsSelectedClick() {
    this.reportsSelected = [];
  }

  private addRemoveFileFormatSelected(fileFormat : string) {
      let fileFormatPosition = this.fileFormatsForFilterSelected.indexOf(fileFormat);
      if (fileFormatPosition === -1)
          this.fileFormatsForFilterSelected.push(fileFormat);
      else
          this.fileFormatsForFilterSelected.slice(fileFormatPosition, 1);

      this.getReports(false);
  }

  private getDictionaries() {
    forkJoin(
      this.commonService.getAreaDictionary(),
      this.commonService.getClientGroupsDictionary(),
      this.commonService.getInstitutionDictionary(),
      this.commonService.getProductsDictionary(),
      this.commonService.getFrequencyDictionary(),
      this.commonService.getContentTypeDictionary(),
      this.userReportsService.getFileFormats()
    ).subscribe(([areas, clientGroups, institutions, products, frequencies, contentTypes,fileFormatsResult]) => {
        this.thematicsAreaForFilter = areas;
        this.thematicsClientGroupsForFilter = clientGroups;
        this.thematicsInstitutionForFilter = institutions;
        this.thematicsProductsForFilter = products;
        this.contentTypeForFilter = contentTypes;
        this.thematicsFrequenciesForFilter = frequencies;
        this.fileFormatsForFilter = fileFormatsResult;
        },
        (error) => {
            this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, "Wystąpił błąd! Nie pobrano słowników");
            console.log("Wystąpił błąd! Nie pobrano słowników:", JSON.stringify(error));
        });
  }

  orderByClick(orderByField : string) {
    if (orderByField === this.orderByField)
        this.orderAsc = !this.orderAsc;
    else {
        this.orderAsc = true;
        this.orderByField = orderByField;
    }
    this.getReports(true);
  }

  private createSortString() : string {
      let sortString = '';
      if (this.orderAsc)
          sortString = this.orderByField.concat(" ASC");
      else
          sortString = this.orderByField.concat(" DESC");

      return sortString;
  }

  private setPage(page: number) {
    this.currentPage = page;
    this.pager = this.pagerService.getPager(this.reports.length, page, UserSavedReportsComponent.pageSize);
    this.pagedReports = this.reports.slice(
      this.pager.startIndex,
      this.pager.endIndex + 1
    )
  }

  shareReportClick() {
    let email = this.shareReportForm.controls['email'].value;
    let message = this.shareReportForm.controls['message'].value;
    this.commonService.shareReport(this.reportToOperateOn.id, this.loggedUser.id, email, message).subscribe(
      result=>{
        if (result.status==1)
          this.notifierService.notify(NotificationType.SUCCESS_NOTIFICATION, "Wysłano link do raportu");
        else
          this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, "Wystąpił błąd: Link nie został wysłany");

        this.showReportShare = false;
        this.reportToOperateOn = undefined;
        this.shareReportForm.controls['email'].reset('');
        this.shareReportForm.controls['message'].reset('');
      });
  }

  showReportSharePopup(show : boolean, reportToOperateOn? : Report) {
    this.showReportShare = show;

    if (reportToOperateOn)
      this.reportToOperateOn = reportToOperateOn;

    if (!show)
      this.reportToOperateOn = undefined;
    else
      this.shareReportForm.controls['email'].setValue('');
  }


  private downloadReportClick(report : Report) {
    this.commonService.downloadReportFile(report.id).subscribe(
      data=> {
        saveAs(data, report.fileName);
      },
      err => {
        console.log(err);
        this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, "Wystąpił błąd! Nie można pobrać wskazanego raportu")
      }
    )
  }

  private downloadDemoClick(report: Report) {
    this.commonService.downloadDemoFile(report.id).subscribe(
      data=>{
        saveAs(data, report.demoFileName);
      },
      err => {
        console.log(err);
        this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, "Wystąpił błąd! Nie można pobrać DEMO wskazanego raportu")
      }
    )
  }

  private showGetDemoPopupClick(show : boolean, report ?: Report) {
    this.showNoAccessPopup = show;
    if (show)
      this.currentReport = report;
    else
      this.currentReport = undefined;
  }

  showContatUsPopupClick(show : boolean, report? : Report) {
    this.showContactUsPopup = show;
    if (show) {
      this.reportToOperateOn = report;
      this.contactForm.controls['message'].setValue('Dzień dobry,\n\npoproszę o ofertę dotyczącą raportu \"'
        .concat(report.title, '\" \n\nPozdrawiam\n', this.loggedUser.firstName, ' ', this.loggedUser.lastName));
      this.commonService.registerClickOnElement('clickOnAskForOffer','savedReportsList', 'report', report.id).subscribe(
        success => {
          if (success.status != 1)
            console.log(success.message);
        },
        error => {
          console.log(error);
        }
      );
    } else {
      this.contactForm.controls['agreement-rules'].setValue(false);
      this.contactForm.controls['send-copy'].setValue(false);
    }
  }

  sendAccessRequest() {
    let sendCopy = this.contactForm.controls['send-copy'].value;
    let message = this.contactForm.controls['message'].value;
    this.commonService.sendAccessRequestUrl(this.loggedUser.id, this.reportToOperateOn.id, message, sendCopy).subscribe(
      result => {
        if (result.status ==1)
          this.notifierService.notify(NotificationType.SUCCESS_NOTIFICATION,
            "Wysłano prośbę o dostęp do raportu");
        else
          this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
            "Wystąpił błąd! Nie wysłano maila z prośbą o dostęp")
      },
      error => {
        console.log(error);
        this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
          "Wystąpił błąd! Nie wysłano maila z prośbą o dostęp")
      }
    );

  }
}
